import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService, Product } from '../../services/api.service';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <section class="min-h-screen pt-24 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="fade-in-left text-center mb-12">
          <div class="inline-flex items-center gap-2 bg-primary/10 rounded-full px-4 py-2 mb-4">
            <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg>
            <span class="text-sm font-medium text-primary">فروشگاه</span>
          </div>
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-black mb-4">محصولات <span class="text-primary">ورزشی</span></h2>
          <p class="text-muted-foreground max-w-2xl mx-auto">بهترین مکمل‌ها، تجهیزات و لوازم ورزشی با کیفیت عالی</p>
        </div>

        <!-- Features bar -->
        <div class="fade-in-left grid sm:grid-cols-3 gap-4 mb-8" style="animation-delay: 0.1s">
          <div class="flex items-center gap-3 bg-muted/50 rounded-xl p-4">
            <svg class="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"/></svg>
            <span class="text-sm font-medium">ارسال رایگان بالای ۵۰۰ هزار تومان</span>
          </div>
          <div class="flex items-center gap-3 bg-muted/50 rounded-xl p-4">
            <svg class="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
            <span class="text-sm font-medium">۷ روز ضمانت بازگشت کالا</span>
          </div>
          <div class="flex items-center gap-3 bg-muted/50 rounded-xl p-4">
            <svg class="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
            <span class="text-sm font-medium">تضمین اصالت کالا</span>
          </div>
        </div>

        <!-- Filters -->
        <div class="flex flex-col sm:flex-row gap-4 mb-8">
          <div class="flex flex-wrap gap-2 flex-1">
            <button *ngFor="let cat of categories" (click)="changeCategory(cat.value)"
              [ngClass]="selectedCategory === cat.value ? 'bg-primary text-primary-foreground' : 'border border-border text-foreground hover:bg-accent'"
              class="px-4 py-2 rounded-lg text-sm font-medium transition-colors">{{ cat.label }}</button>
          </div>
          <div class="relative">
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
            <input [(ngModel)]="searchQuery" (ngModelChange)="onSearch()" type="text" placeholder="جستجو..."
              class="pr-9 w-40 sm:w-56 h-9 text-sm rounded-lg bg-background border border-input px-3 py-1 focus:outline-none focus:ring-2 focus:ring-ring"/>
          </div>
        </div>

        <!-- Products count -->
        <div class="flex items-center justify-between mb-6">
          <span class="text-sm text-muted-foreground">نمایش {{ startIndex + 1 }} تا {{ getMin(startIndex + itemsPerPage, filteredProducts.length) }} از {{ filteredProducts.length }} محصول</span>
        </div>

        <!-- Products Grid -->
        <div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 stagger-children">
          <div *ngFor="let product of paginatedProducts" class="bg-card border border-border rounded-xl overflow-hidden sports-card group">
            <div class="relative h-44 overflow-hidden">
              <img [src]="product.image" [alt]="product.name" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"/>
              <div class="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent"></div>
              <div *ngIf="!product.stock" class="absolute inset-0 bg-background/60 flex items-center justify-center">
                <span class="bg-destructive text-white text-xs px-3 py-1 rounded-full">ناموجود</span>
              </div>
              <div class="absolute top-2 left-2">
                <span class="bg-primary/80 text-primary-foreground text-xs px-2 py-1 rounded">{{ product.category }}</span>
              </div>
            </div>
            <div class="p-4 space-y-3">
              <h3 class="text-sm font-bold line-clamp-2 leading-6">{{ product.name }}</h3>
              <div class="flex items-center gap-1">
                <svg class="w-3.5 h-3.5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/></svg>
                <span class="text-xs font-medium">{{ product.rating }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="text-base font-black text-primary">{{ product.price }}</span>
                <span class="text-xs text-muted-foreground">تومان</span>
              </div>
              <div *ngIf="product.oldPrice" class="text-xs text-muted-foreground line-through">{{ product.oldPrice }} تومان</div>
              <button [disabled]="!product.stock" class="w-full bg-primary text-primary-foreground py-2 rounded-lg text-xs font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                افزودن به سبد
              </button>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div *ngIf="totalPages > 1" class="flex items-center justify-center gap-2 mt-10">
          <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            class="p-2 rounded-lg border border-border disabled:opacity-50 hover:bg-accent transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
          </button>
          <button *ngFor="let page of pages" (click)="goToPage(page)"
            [ngClass]="currentPage === page ? 'bg-primary text-primary-foreground' : 'border border-border hover:bg-accent'"
            class="w-10 h-10 rounded-lg text-sm font-medium transition-colors">{{ page }}</button>
          <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="p-2 rounded-lg border border-border disabled:opacity-50 hover:bg-accent transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
          </button>
        </div>
      </div>
    </section>
  `,
  styles: [':host { display: block; }']
})
export class ProductsComponent implements OnInit {
  allProducts: Product[] = [];
  filteredProducts: Product[] = [];
  paginatedProducts: Product[] = [];
  currentPage = 1;
  itemsPerPage = 15;
  selectedCategory = 'all';
  searchQuery = '';

  categories = [
    { label: 'همه', value: 'all' },
    { label: 'مکمل ها', value: 'مکمل' },
    { label: 'تجهیزات', value: 'تجهیزات' },
    { label: 'پوشاک', value: 'پوشاک' },
    { label: 'لوازم جانبی', value: 'لوازم' },
  ];

  get startIndex(): number { return (this.currentPage - 1) * this.itemsPerPage; }
  get totalPages(): number { return Math.ceil(this.filteredProducts.length / this.itemsPerPage); }
  get pages(): number[] { return Array.from({ length: this.totalPages }, (_, i) => i + 1); }

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadProducts();
  }

  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }

  loadProducts(): void {
    this.apiService.getProducts().subscribe({
      next: (res: any) => {
        this.allProducts = res.data || res;
        this.applyFilters();
      },
      error: () => {
        this.allProducts = this.getMockProducts();
        this.applyFilters();
      }
    });
  }

  private applyFilters(): void {
    this.filteredProducts = this.allProducts.filter(p => {
      const matchCat = this.selectedCategory === 'all' || p.category === this.selectedCategory;
      const matchSearch = p.name.includes(this.searchQuery) || p.category.includes(this.searchQuery);
      return matchCat && matchSearch;
    });
    this.currentPage = 1;
    this.updatePaginated();
  }

  private updatePaginated(): void {
    const start = this.startIndex;
    this.paginatedProducts = this.filteredProducts.slice(start, start + this.itemsPerPage);
  }

  changeCategory(cat: string): void {
    this.selectedCategory = cat;
    this.applyFilters();
  }

  onSearch(): void {
    this.applyFilters();
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginated();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  private getMockProducts(): Product[] {
    return [
      { id: 1, name: 'پروتئین وی گلد استاندارد', category: 'مکمل', price: '۲,۴۰۰,۰۰۰', oldPrice: '۲,۹۰۰,۰۰۰', rating: 4.9, stock: true, image: 'https://images.unsplash.com/photo-1593095948071-474c5cc2c238?w=400&q=80', description: '' },
      { id: 2, name: 'کراتین مونوهیدرات', category: 'مکمل', price: '۱,۸۰۰,۰۰۰', oldPrice: '', rating: 4.8, stock: true, image: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?w=400&q=80', description: '' },
      { id: 3, name: 'BCAA پودری', category: 'مکمل', price: '۹۵۰,۰۰۰', oldPrice: '۱,۲۰۰,۰۰۰', rating: 4.7, stock: true, image: 'https://images.unsplash.com/photo-1579722821273-0f6c7d44362f?w=400&q=80', description: '' },
      { id: 4, name: 'پری وورک اوت', category: 'مکمل', price: '۱,۱۰۰,۰۰۰', oldPrice: '', rating: 4.6, stock: true, image: 'https://images.unsplash.com/photo-1599058917765-a780eda07a3e?w=400&q=80', description: '' },
      { id: 5, name: 'دمبل ۲۰ کیلوگرمی', category: 'تجهیزات', price: '۸,۵۰۰,۰۰۰', oldPrice: '', rating: 4.9, stock: true, image: 'https://images.unsplash.com/photo-1638536532686-d610adfc8e5c?w=400&q=80', description: '' },
      { id: 6, name: 'ست هالتر کامل', category: 'تجهیزات', price: '۲۵,۰۰۰,۰۰۰', oldPrice: '۳۰,۰۰۰,۰۰۰', rating: 4.8, stock: true, image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80', description: '' },
      { id: 7, name: 'بنچ پرس حرفه ای', category: 'تجهیزات', price: '۱۸,۰۰۰,۰۰۰', oldPrice: '', rating: 4.7, stock: false, image: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=400&q=80', description: '' },
      { id: 8, name: 'میله کششی درب', category: 'تجهیزات', price: '۲,۲۰۰,۰۰۰', oldPrice: '۲,۸۰۰,۰۰۰', rating: 4.5, stock: true, image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&q=80', description: '' },
      { id: 9, name: 'تردمیل خانگی', category: 'تجهیزات', price: '۴۵,۰۰۰,۰۰۰', oldPrice: '۵۲,۰۰۰,۰۰۰', rating: 4.9, stock: true, image: 'https://images.unsplash.com/photo-1576678927484-cc907957088c?w=400&q=80', description: '' },
      { id: 10, name: 'ست لباس ورزشی مردانه', category: 'پوشاک', price: '۱,۹۵۰,۰۰۰', oldPrice: '۲,۵۰۰,۰۰۰', rating: 4.6, stock: true, image: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400&q=80', description: '' },
      { id: 11, name: 'کفش ورزشی نایک', category: 'پوشاک', price: '۶,۸۰۰,۰۰۰', oldPrice: '', rating: 4.8, stock: true, image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80', description: '' },
      { id: 12, name: 'ساق بند طبی', category: 'لوازم', price: '۴۵۰,۰۰۰', oldPrice: '', rating: 4.4, stock: true, image: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=400&q=80', description: '' },
      { id: 13, name: 'دستکش بدنسازی چرمی', category: 'لوازم', price: '۷۸۰,۰۰۰', oldPrice: '۹۵۰,۰۰۰', rating: 4.7, stock: true, image: 'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&q=80', description: '' },
      { id: 14, name: 'کمربند بدنسازی', category: 'لوازم', price: '۱,۵۰۰,۰۰۰', oldPrice: '', rating: 4.8, stock: true, image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&q=80', description: '' },
      { id: 15, name: 'شیکر ورزشی', category: 'لوازم', price: '۳۵۰,۰۰۰', oldPrice: '', rating: 4.3, stock: true, image: 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=400&q=80', description: '' },
      { id: 16, name: 'مولتی ویتامین ورزشی', category: 'مکمل', price: '۶۵۰,۰۰۰', oldPrice: '۸۰۰,۰۰۰', rating: 4.5, stock: true, image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&q=80', description: '' },
      { id: 17, name: 'گلوتامین پودری', category: 'مکمل', price: '۸۵۰,۰۰۰', oldPrice: '', rating: 4.6, stock: true, image: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=400&q=80', description: '' },
      { id: 18, name: 'فوم رولر', category: 'لوازم', price: '۹۸۰,۰۰۰', oldPrice: '۱,۲۰۰,۰۰۰', rating: 4.4, stock: true, image: 'https://images.unsplash.com/photo-1599058917765-a780eda07a3e?w=400&q=80', description: '' },
      { id: 19, name: 'ست resistence band', category: 'تجهیزات', price: '۵۵۰,۰۰۰', oldPrice: '', rating: 4.6, stock: true, image: 'https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=400&q=80', description: '' },
      { id: 20, name: 'توپ یوگا حرفه ای', category: 'تجهیزات', price: '۴۲۰,۰۰۰', oldPrice: '', rating: 4.5, stock: true, image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&q=80', description: '' },
      { id: 21, name: 'کاور کفش ورزشی', category: 'پوشاک', price: '۲۸۰,۰۰۰', oldPrice: '', rating: 4.2, stock: true, image: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400&q=80', description: '' },
      { id: 22, name: 'استپ ورزشی', category: 'تجهیزات', price: '۱,۶۰۰,۰۰۰', oldPrice: '۲,۰۰۰,۰۰۰', rating: 4.7, stock: false, image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=400&q=80', description: '' },
      { id: 23, name: 'ساعت ورزشی هوشمند', category: 'لوازم', price: '۹,۸۰۰,۰۰۰', oldPrice: '۱۲,۰۰۰,۰۰۰', rating: 4.9, stock: true, image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&q=80', description: '' },
    ];
  }
}